module.exports = __webpack_public_path__ + "img/icon-mp_2.abb30e57.png";